import Joi from 'joi';

import { TagRecordCategoryEnum } from '../../enums/tag-record-category.enum';

/**
 * Schema for existing record validation.
 */
export const updateTagSchema = () =>
  Joi.object({
    id: Joi.alternatives().conditional(Joi.any().valid(null), {
      then: Joi.invalid(null).messages({
        'any.invalid': 'validations|tag-id|cannot-be-null',
      }),
      otherwise: Joi.number().required().messages({
        'any.required': 'validations|tag-id|required',
        'number.base': 'validations|tag-id|must-be-number',
      }),
    }),

    name: Joi.alternatives().conditional(Joi.any().valid(null), {
      then: Joi.invalid(null).messages({
        'any.invalid': 'validations|tag-name|cannot-be-null',
      }),
      otherwise: Joi.string().required().messages({
        'any.required': 'validations|tag-name|required',
        'string.base': 'validations|tag-name|must-be-string',
        'string.empty': 'validations|tag-name|cannot-be-empty',
      }),
    }),

    recordCategory: Joi.alternatives().conditional(Joi.any().valid(null), {
      then: Joi.invalid(null).messages({
        'any.invalid': 'validations|tag-record-category|cannot-be-null',
      }),
      otherwise: Joi.string()
        .valid(...Object.values(TagRecordCategoryEnum))
        .required()
        .messages({
          'any.required': 'validations|tag-record-category|required',
          'any.only': 'validations|tag-record-category|invalid-value',
        }),
    }),

    notes: Joi.string().allow(null, '').messages({
      'string.base': 'validations|tag-notes|must-be-string',
    }),

    description: Joi.string().allow(null, '').messages({
      'string.base': 'validations|tag-description|must-be-string',
    }),
  })
    // Ignore extra fields
    .unknown();
